import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input, EventEmitter, Output } from "@angular/core";

// Angular Material
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";

// Rxjs
import { Observable } from "rxjs";
import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';


// Customer (Service - Model - Component)
//import { CustomerService } from "../../../commons/services/customer.service";
import { Customer, CustomersFilters } from "../../../commons/models/customer";
import { NewCustomerComponent } from "../../home/modules/customers/components/new-customer/new-customer.component";

@Component({
  selector: "app-customer-list",
  templateUrl: "./customer-list.component.html",
  styleUrls: ["./customer-list.component.scss"]
})
export class CustomerListComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  pageSizeOptions = PAGE_SIZE_OPTIONS;


  @Input() customers: Customer[];
  @Input() defaultFilters: CustomersFilters;
  @Input() total: Observable<number>;

  @Input() selectedCustomers: Customer[];
  @Input() displayedColumns = ["surname", "name", "phone", "fidelity_card_points", "active", "actions"];
  @Input()
  canAdd: boolean;
  @Input()
  canEdit: boolean;
  @Input()
  canSelect: boolean;

  @Output()
  onLoad: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
  @Output()
  onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output()
  onFilterChange: EventEmitter<CustomersFilters> = new EventEmitter<CustomersFilters>();

  @Output()
  onSelectCustomer: EventEmitter<Customer> = new EventEmitter<Customer>();
  @Output()
  onAddCustomer: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onEditCustomer: EventEmitter<Customer> = new EventEmitter<Customer>();
  @Output()
  onShowCustomer: EventEmitter<Customer> = new EventEmitter<Customer>();
  @Output()
  onAddSelectedCustomer: EventEmitter<Customer> = new EventEmitter<Customer>();
  @Output()
  onRemoveSelectedCustomer: EventEmitter<Customer> = new EventEmitter<Customer>();


  get selectedItems(): boolean {
    return this.selectedCustomers.length > 0;
  }



  // ngOnInit() {
  //   this.dataSource = new CustomerDataSource(this.customerService);
  //   this.dataSource.loadCustomers();
  // }

  // ngAfterViewInit() {
  //   // server-side search
  //   fromEvent(this.input?.nativeElement, "keyup")
  //     .pipe(
  //       debounceTime(200),
  //       distinctUntilChanged(),
  //       tap(() => {
  //         this.paginator.pageIndex = 0;
  //         this.loadCustomers();
  //       })
  //     )
  //     .subscribe();

  //   this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

  //   merge(this.sort.sortChange, this.paginator.page)
  //     .pipe(tap(() => this.loadCustomers()))
  //     .subscribe();
  // }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort) => {
      this.onSortChange.emit(sort);
    });
    this.paginator.page.subscribe((pageEvent) => {
      this.onPageChange.emit(pageEvent);
    });
  }

  isSelected(customer: Customer): boolean {
    return this.selectedCustomers.map(obj => obj.id).includes(customer.id)
  }

  addCustomer() {
    this.onAddCustomer.emit();
  }

  addSelectedCustomer(customer: Customer) {
    if(this.isSelectable(customer)) {
      this.onAddSelectedCustomer.emit(customer);
    }
  }

  isSelectable(customer: Customer): boolean {
    return !customer.id
  }

  removeSelectedCustomer(customer: Customer) {
    this.onRemoveSelectedCustomer.emit(customer)
  }

  toggleSelectedCustomer(customer: Customer) {
    if (this.isSelected(customer)) {
      this.removeSelectedCustomer(customer);
    } else {
      this.addSelectedCustomer(customer);
    }
  }

  editCustomer(customer: Customer) {
    this.onEditCustomer.emit(customer);
  }

  selectCustomer(customer: Customer) {
    this.onSelectCustomer.emit(customer);
  }

  onFilter(filters: CustomersFilters) {
    this.paginator.firstPage();
    this.onFilterChange.emit(filters);
    //console.log("firstpage:", this.paginator.firstPage());
  }

  showCustomer(activityList: Customer) {
    this.onShowCustomer.emit(activityList);
  }

  onChangeDefaultTenant() {
    this.paginator.pageIndex = 0;
    this.onLoad.emit();
  }

  // getTenantsList(customer: Customer): string {
  //   if (!customer.tenant) {
  //     return 'N/A';
  //   }
  //   return customer.tenant.name;
  // }

  // private loadCustomers() {
  //   const defaultTenantId = this.defaultTenant === 1 ? 1 : null;

  //   this.dataSource.loadCustomers(
  //     this.paginator.pageIndex + 1,
  //     this.paginator.pageSize,
  //     this.sort.active,
  //     this.sort.direction,
  //     this.input.nativeElement.value,
  //     defaultTenantId
  //   );
  // }



}


